export default function(context){
    const el = 'script'
    const type = 'nlx/data'

    const DOMlist = document.querySelectorAll(el)

    DOMlist.forEach(DOM => {
        const elemType = DOM.attributes.type
        const typeValue = elemType ? elemType.nodeValue : ''

        if(typeValue === type){
            const data = JSON.parse(DOM.childNodes[0].textContent)
            context.commit('set_filter_displaynames',data.labels)
        }

    })
}